import React from 'react';

/**
 * Signals to a full-page entity form (facture, avoir, encaissement, dépense…)
 * that it is being rendered **inside a drawer** rather than on its own route.
 *
 * The forms are shared verbatim between the two hosts; only their exit paths
 * differ: on a page they redirect (`history.push('/achats/factures')`) or go
 * back, whereas in a drawer they must simply close the drawer and leave the
 * user exactly where they were (Grand Livre, Balance, a detail drawer…).
 */
export interface EmbeddedFormDrawerValue {
  /** Called once the entity has been created/updated successfully. */
  onSaved: () => void;
  /** Called when the user cancels the form. */
  onCancel: () => void;
}

const EmbeddedFormDrawerContext =
  React.createContext<EmbeddedFormDrawerValue | null>(null);

export const EmbeddedFormDrawerProvider = EmbeddedFormDrawerContext.Provider;

/**
 * Returns the embedding drawer handlers, or `null` when the form is rendered
 * as a standalone page (the normal routing behaviour then applies).
 */
export const useEmbeddedFormDrawer = (): EmbeddedFormDrawerValue | null =>
  React.useContext(EmbeddedFormDrawerContext);
